import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import lottoService from '../../services/lotto/lottoService';
import './LottoWheelSelector.css';

/**
 * Component to select and display Lotto wheels
 */
const LottoWheelSelector = ({ onWheelSelected, selectedWheel }) => {
  const { t } = useTranslation();
  const [wheels, setWheels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadWheels();
  }, []);

  const loadWheels = async () => {
    try {
      setLoading(true);
      const data = await lottoService.getAllWheels();
      setWheels(data);
      if (data.length > 0 && !selectedWheel) {
        onWheelSelected(data[0]);
      }
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error loading wheels:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="lotto-wheel-selector loading">Loading wheels...</div>;
  }

  if (error) {
    return (
      <div className="lotto-wheel-selector error">
        <p>Error loading wheels: {error}</p>
        <button onClick={loadWheels}>Retry</button>
      </div>
    );
  }

  return (
    <div className="lotto-wheel-selector">
      <h3>{t('lotto.wheels') || 'Lotto Wheels'}</h3>
      <div className="wheel-buttons">
        {wheels.map((wheel) => (
          <button
            key={wheel.code}
            className={`wheel-btn ${selectedWheel?.code === wheel.code ? 'active' : ''}`}
            onClick={() => onWheelSelected(wheel)}
            title={wheel.name}
          >
            <span className="wheel-code">{wheel.code}</span>
            <span className="wheel-name">{wheel.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LottoWheelSelector;
